import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { ASSETS } from "@/data/site";

const NAV = [
  { label: "Leistungen", href: "#leistungen" },
  { label: "Warum wir", href: "#warum-wir" },
  { label: "Über uns", href: "#ueber-uns" },
  { label: "Team", href: "#team" },
  { label: "FAQ", href: "#faq" },
  { label: "Kontakt", href: "#kontakt" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const onHome = pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goSection = (href) => {
    setOpen(false);
    if (!onHome) {
      window.location.href = "/" + href;
      return;
    }
    const id = href.replace("#", "");
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-ink-900/80 border-b border-ink-500/60"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-12 h-20 flex items-center justify-between">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-3 group">
          <img
            src={ASSETS.logo}
            alt="Five Star Reinigung"
            className="h-14 md:h-16 w-auto object-contain"
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((item) => (
            <button
              key={item.href}
              data-testid={`nav-${item.href.replace("#", "")}`}
              onClick={() => goSection(item.href)}
              className="text-sm text-zinc-300 hover:text-gold transition-colors duration-300"
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <button
            data-testid="header-cta-angebot"
            onClick={() => goSection("#kontakt")}
            className="px-5 py-2.5 bg-gold text-ink-900 text-sm font-medium tracking-wide uppercase hover:bg-gold-hover transition-colors duration-300"
          >
            Angebot anfragen
          </button>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          aria-label="Menü"
          className="lg:hidden text-white"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-ink-900/95 backdrop-blur-xl border-t border-ink-500/60">
          <div className="px-6 py-6 flex flex-col gap-4">
            {NAV.map((item) => (
              <button
                key={item.href}
                data-testid={`mobile-nav-${item.href.replace("#", "")}`}
                onClick={() => goSection(item.href)}
                className="text-left text-zinc-200 hover:text-gold transition-colors py-2 border-b border-ink-500/40"
              >
                {item.label}
              </button>
            ))}
            <button
              data-testid="mobile-cta-angebot"
              onClick={() => goSection("#kontakt")}
              className="mt-2 px-5 py-3 bg-gold text-ink-900 text-sm font-medium tracking-wide uppercase"
            >
              Angebot anfragen
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
